function enjoyYourLayoutShift() {
  document.querySelectorAll('main .wp-block-columns').forEach((columns) => {
    const selectors = ['.wp-block-heading', 'p'];

    selectors.forEach((selector: string) => {
      const heights = [...columns.querySelectorAll(selector)].map((node) => {
        const {height} = node.getBoundingClientRect();
        return height;
      });
      const maxHeight = Math.max(...heights);

      columns.querySelectorAll(selector).forEach((node) => {
        (node as HTMLElement).style.height = `${maxHeight}px`;
      });
    });
  });
}

export default function main() {
  window.addEventListener('load', () => {
    enjoyYourLayoutShift();
  });
}
